import { IElement } from '../types/IElement'
import React, { useState, FC, useContext } from 'react'
import { ViewElement } from '../ViewElement'
import VisibilitySensor from '@k.sh/react-visibility-sensor'
import { TopicDetailContext } from '../TopicDetailContext'

interface IProps {
  element: IElement
  index: number
  onIsVisible: (index: number) => void
}

export const SinglePageElement: FC<IProps> = (props) => {
  const { topic } = useContext(TopicDetailContext)
  const { element, index, onIsVisible } = props
  const { type, id } = element

  const [isVisible, setIsVisible] = useState(false)

  return (
    <div className={`page page-${type}`} key={id}>
      <VisibilitySensor
        partialVisibility="bottom"
        onChange={(isVisible: boolean) => {
          // these events are triggered from top to bottom when there are multiple visible elements, so we rely on that behaviour and debounce
          if (isVisible) {
            onIsVisible(index)
            setIsVisible(isVisible)
          }
        }}
      >
        <div
          className={`ql-editor page-content page-content-${type} element element-${type} element-mode-view`}
        >
          <ViewElement
            {...element}
            topicId={topic.id}
            isVisible={isVisible}
            shouldTrackMedia={true}
            quizResponses={topic?.enrolmentOrSelfEnrol?.quizResponses || []}
            allowRetry={!!topic?.currentTopicVersion?.allow_retry}
          />
        </div>
      </VisibilitySensor>
    </div>
  )
}
